import { getState } from 'lib/store'
import type { Log } from 'types/search/logs'

/**
 * Get logs items
 */
export const getLogs = (): Log[] => {
  return getState().search.logs.items
}

/**
 * Get logs next token for pagination
 */
export const getLogsNextToken = (): string | null => {
  return getState().search.logs.nextToken
}

/**
 * Check if logs are being fetched (initial load)
 */
export const isFetchingLogs = (): boolean => {
  return getState().search.logs.isFetching
}

/**
 * Check if more logs are being fetched (pagination load more)
 */
export const isFetchingMoreLogs = (): boolean => {
  return getState().search.logs.isFetchingMore
}

/**
 * Check if there are more logs to load
 */
export const hasMoreLogs = (): boolean => {
  return getState().search.logs.nextToken !== null
}
